import { Component, Input } from '@angular/core';
import {Helper} from '../../classes/helpers';

@Component({
  selector: 'app-preloader',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
})
export class PreloaderComponent {
  @Input() public secondaryColor: boolean;

  constructor() {
  }
}
